"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var currencies_1 = require("./currencies");
var video_deal_info_1 = require("./video-deal-info");
exports.DEFAULT_VOD_SETTINGS = {
    allowDownload: false,
    currency: currencies_1.DEFAULT_CURRENCY,
    memberOnly: false,
    dealInfo: video_deal_info_1.DEFAULT_VIDEO_DEAL_INFO,
};
//# sourceMappingURL=default-vod-settings.js.map